
import InputCamera from '../../components/form/posts/inputCamera';
import InputLink from '../../components/form/posts/inputLink';
import InputImg from '../../components/form/posts/inputImg';
import InputThumbnail from '../../components/form/posts/inputThumbnail';
import KakaoHelper from '../../utils/KakaoHelper';

export default {
  components: { InputThumbnail, InputImg, InputLink, InputCamera },
  auth: false,
  data() {
    return {
      item: {
        user: {},
      },

      form: {},

      errors: {},

      activeScrapPop: false,

      map: '',

      tabIndex: 0,

      activeSpamPop: false,

      loading: false,
    };
  },
  methods: {
    store() {},

    share() {
      let kakaoHelper = new KakaoHelper(Kakao);

      kakaoHelper.sharePost(this.item);
    },
  },

  mounted() {
    try {
      this.$axios
        .get('/api/notices/' + this.$route.params.id)
        .then((response) => {
          this.item = response.data.data;
          console.log(response.data.data);
          this.loading = true;
        });
    } catch (e) {
      console.log(e);
    }
  },
};
